import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, map, tap, throwError } from 'rxjs';

import { User } from '../models/user.model';

const AUTH_KEY = 'ema-user';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  readonly currentUser = signal<User | null>(this._readStored());

  login(username: string, password: string): Observable<User> {
    return this.http.post<User>('/api/auth/login', { username, password }).pipe(
      tap((user) => {
        localStorage.setItem(AUTH_KEY, JSON.stringify(user));
        this.currentUser.set(user);
      })
    );
  }

  logout(): void {
    localStorage.removeItem(AUTH_KEY);
    this.currentUser.set(null);
  }

  changePassword(currentPassword: string, newPassword: string): Observable<void> {
    const user = this.currentUser();
    if (!user?.nhanvien_id) {
      return throwError(() => new Error('Chưa đăng nhập'));
    }

    return this.http.post<{ ok: true }>(
      '/api/auth/change-password',
      { current_password: currentPassword, new_password: newPassword },
      { headers: { 'X-Nhanvien-Id': String(user.nhanvien_id) } }
    ).pipe(
      map(() => void 0)
    );
  }

  patchIsChangePassword(value: boolean): void {
    const current = this._readStored();
    if (!current) {
      this.currentUser.set(null);
      return;
    }

    const next: User = { ...current, is_changepassword: value };
    localStorage.setItem(AUTH_KEY, JSON.stringify(next));
    this.currentUser.set(next);
  }

  isAuthenticated(): boolean {
    return !!this.currentUser();
  }

  isNhanVien(): boolean {
    return this.currentUser()?.mavaitro === 'NV';
  }

  isCTV(): boolean {
    return this.currentUser()?.mavaitro === 'CTV';
  }

  isQLCTV(): boolean {
    return this.currentUser()?.mavaitro === 'QLCTV';
  }

  isAdmin(): boolean {
    return this.currentUser()?.mavaitro === 'Admin';
  }

  private _readStored(): User | null {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? (JSON.parse(raw) as User) : null;
  }
}
